// extracted by mini-css-extract-plugin
export default {"form":"EditWorkshop_form__K79JB","section":"EditWorkshop_section__T+KJ0","highlight":"EditWorkshop_highlight__qMuHM","sectionTitle":"EditWorkshop_sectionTitle__FOkGy"};